import styled from 'styled-components';
import { theme } from '../../styled/layout/theme';

export const Banner = styled.div<{ $bg: string; $color: string }>`
    padding: var(--mio-size-space-300) var(--mio-size-space-600);
    background-color: ${({ $bg }) => $bg};
    color: ${({ $color }) => $color};
    background: ${({ $bg }) => $bg};
`;

export const Dot = styled.div`
    margin: 0 var(--mio-size-space-200);
`;

export const Message = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    ${theme.screens.LtMd} {
        flex-direction: column;
        align-items: flex-start;

      ${Dot} {
        display: none;
      }
    }
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: var(--mio-size-space-200);

    ${theme.screens.LtMd} {
      justify-content: space-between;
    }
`;

export const BannersWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;

    ${theme.screens.LtMd} {
      flex-direction: column;
    }

    ${Banner} {
      flex: 1 1 50%;
    }

`;
